<template>
	<div class="TotalOnline-people">
		<div class="TotalOnline-cont">
			<div class="TotalOnline-title">
				<span>总分分档上线人数分布</span>
				<span>总分分档上线学生人数分布，可得到本次考试下各班级在学业综合水平上的分层表现</span>
			</div>
			<div class="level-desc">
				<p>
					<span>{{ gradeLine }}</span>
				</p>
				<p>
					<span> {{ gradingGrade }}</span>
				</p>
				<p>
					<span>临界生：全校及各班级的总分在不同分档分数线左右徘徊的人数。</span>
				</p>
				<div class="setting-grading">
					<el-select v-model="grading" size="mini" placeholder="选择分档" @change="chageGrading">
						<el-option v-for="item in options" :key="item.type" :label="item.label" :value="item.type"> </el-option>
					</el-select>
				</div>
				<!-- <div class="set-level-btn" @click="dialogVisible = true">设置分档参数</div> -->
			</div>
			<div class="set-grade-avg"></div>
			<div class="totalStudents">
				{{ totalStudentsGrading }}
			</div>
			<div class="onlinePepple-table">
				<div class="online-desc">
					<span>各班级的上线情况见下表：</span>
				</div>
				<div class="online-table-show" style="display: flex">
					<tables :tableOptions="classOnlineData"></tables>
				</div>
			</div>
			<div class="onlinePeople-show">
				<p>分析诊断：</p>
				<p>
					如上图各班级上线人数分布所示，基本上反映出各个班级总分较高学生的人数分布情况。下面重点列出各档累计上线率最高和最低的班级：
				</p>
				<div class="level-block" style="display: flex;justify-content: space-between">
					<div class="level-block-desc">
						<div class="block-cont">
							<div class="block-item" v-for="(maxItem, maxIndex, index) in maxClass" :key="maxIndex" v-show="index < 3">
								<p class="cls-wrap-title">{{ index | filterIndex }}档上线率高的班级</p>
								<div class="cls-wrap">
									<span
										style="color: #009688"
										class="cls-wrap-list"
										v-for="(maxListItem, maxListIndex) in maxItem"
										:key="`${maxIndex}-${maxListIndex}`"
										>{{ maxListItem.className }}</span
									>
								</div>
							</div>
						</div>
						<div class="block-cont">
							<div class="block-item" v-for="(minItem, minIndex, index) in minClass" :key="minIndex" v-show="index < 3">
								<p class="cls-wrap-title">{{ index | filterIndex }}档上线率低的班级</p>
								<div class="cls-wrap">
									<span
										style="color: red"
										class="cls-wrap-list"
										v-for="(minListItem, minListIndex) in minItem"
										:key="`${minIndex}-${minListIndex}`"
										>{{ minListItem.className }}</span
									>
								</div>
							</div>
						</div>
					</div>
					<div class="chart-block">
						<div class="block-select">
							<el-select v-model="classes" size="mini" placeholder="请选择" @change="chageSelect">
								<el-option v-for="item in totalClasses" :key="item.classId" :label="item.className" :value="item.classId"> </el-option>
							</el-select>
						</div>
						<div>
							<render-Total-Grade-Online-People :newClasses="classes" :classData="classData" />
						</div>
					</div>
				</div>
			</div>
			<div class="critical-desc"></div>
			<div class="class-test-cont">
				<div class="classTest-title">
					<span>班级上档人数分布</span>
					<span
						>通过各班在数据上的突出表现及其差异，来分析不同班级之间的考试表现情况，但要注意结合各班级的实际教学情况及历史原因，做客观分析判断。</span
					>
				</div>
				<div class="classTest-show">
					<render-Class-Test-Perfom
						:classDataTitle="classDataTitle"
						:classGradeX="classGradeX"
						:newClassData="newClassData"
						:max="max"
						:interval="interval"
					/>
					<div class="classTest-echarts-desc">
						<div class="select-class">
							<el-button type="info" size="mini" @click="openClassDialog">选择班级</el-button>
							<!-- <el-button type="info" plain size="mini" @click="openClassDialog">选择班级</el-button> -->
						</div>
						<div class="HighScore-class">
							<div class="HighScore-class-cont">
								<p>二档累计人数较多的班级：</p>
								<p style="color: #009688">{{ maxClassScore }}</p>
							</div>
						</div>
						<div class="LowScore-class">
							<div class="LowScore-class-cont">
								<p>未上档人数较多的班级：</p>
								<p style="color: red" class="LowScore-p">{{ minClassScore }}</p>
							</div>
						</div>
						<!-- <div class="grade-conclusion">
							<span>
								* 以上结论以各班自身水平为基础推导得出。可能会有较好班级出现低分学生人数多于高分学生人数的现象，
								说明该班级还没有充分挖掘出学生的潜力。此结论有一定的计算算法，切莫将结论直接与左图进行比较。</span
							>
						</div> -->
					</div>
					<div class="setting-class">
						<el-dialog title="选择班级" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
							<div class="class-title">
								<span>班级总数：{{ allSelectClassData.length }}</span>
								<span>已选中班级：{{ checkedclasses.length }}</span>
								<!-- <el-input v-model="className" placeholder="请输入班级名称" size="mini"></el-input> -->
							</div>
							<p class="classTitle-p">
								提示： 为保证图表显示直观清晰，班级数量选择不能超过5个。
							</p>
							<div class="class-select">
								<div v-if="classFlag">
									<p>班级数量选择不能超过5个。</p>
								</div>
								<div v-else style="display: flex; flex-direction: column">
									<!-- <el-checkbox :indeterminate="indeterminate" v-model="checkAllClass" @change="choseAllClass" style="margin-right: 12px"
										>全选</el-checkbox
									> -->
									<el-checkbox-group v-model="checkedclasses" @change="handleCheckedClassesChange">
										<el-checkbox
											v-for="(item, index) in allSelectClassData"
											:label="item.className"
											:key="index"
											:disabled="item.classCheckedFlag"
										>
											{{ item.className }}
										</el-checkbox>
									</el-checkbox-group>
								</div>
							</div>
							<span slot="footer" class="dialog-footer">
								<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
								<el-button type="info" size="mini" @click="closeDialog">确 定</el-button>
							</span>
						</el-dialog>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const subjectOptions = ['语文', '数学', '英语']
export default {
	components: {
		renderTotalGradeOnlinePeople: () => import('./echarts/RenderTotalGradeOnlinePeople'),
		renderClassTestPerfom: () => import('./echarts/RenderClassTestPerfom'),
		tables: () => import('hm-table')
	},
	data() {
		return {
			chartInstance: 'chartInstance',
			checkAllClass: false,
			indeterminate: false,
			gradeLine: '',
			gradingGrade: '',
			totalStudentsGrading: '',
			classOnlineData: [],
			classOneOnlineDataMax: [],
			classOneOnlineDataMin: [],
			classOneOnlineData: [],
			classTwoOnlineData: [],
			classThreeOnlineData: [],
			classOneStuentDataMax: [],
			classOneStuentDataMin: [],
			newClassOneOnlineData: [],
			oneSutentNumData: [],
			totalClasses: [],
			oneOnlineRateMax: '',
			oneOnlineRateMin: '',
			twoOnlineRateMax: '',
			twoOnlineRateMin: '',
			threeOnlineRateMax: '',
			threeOnlineRateMin: '',
			classes: '',
			classes1: '',
			gradingClassData: [],
			dialogVisible: false,
			allSelectClassData: [],
			checkedClassData: [],
			classDataTitle: [],
			newClassData: [],
			resultArr: [],
			classGradeX: [],
			max: 0,
			interval: 0,
			className: '',
			maxClassScore: '',
			minClassScore: '',
			classCheckedFlag: false,
			allSelect: false,
			isIndeterminate: false,
			classFlag: false,
			checkedclasses: [],
			newCheckedClasses: [],
			grading: '按比例分档',
			// classesOnlineData: [],
			classData: [],
			options: [
				{ label: '按比例分档', type: '7' }, //7
				{ label: '按分数分档', type: '8' } //8
			],
			criticalValue: '10',
			defaultGrading: {
				subjectGrade: '1'
			},
			checkAll: false,
			subjects: subjectOptions,
			labelData: [{ grading: '分档', total: '总分', subject: '语文' }],
			flag: false,
			newFlag: true,
			enterFlag: false,
			firstGearData: [],
			secondGearData: [],
			thirdGearData: [],
			minFirstGearData: [],
			minSecondGearData: [],
			minThirdGearData: [],
			classesAll: [],
			size: '',
			classIds: '',
			newClassIds: '',
			query: this.$route.query,
			minClass: [],
			maxClass: [],
			newType: ''
		}
	},
	created() {
		this.getTotalGradeData()
		this.getOnlineRateData()
	},
	filters: {
		filterIndex(val) {
			const type = {
				0: '一',
				1: '二',
				2: '三'
			}
			return type[val]
		}
	},
	// '1024|1'
	methods: {
		getOnlineRateData(classId, type = null) {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				examSubjectId: '',
				type: type
			}
			this.$post('reportApi/gearReportCircleClass', params).then(res => {
				if (res.code == '200') {
					this.totalClasses = res.data.className
					this.classes = classId == null ? res.data.className[0].classId : classId
					res.data.className.forEach(item => {
						if (item.classId == this.classes) {
							let gearClassData = res.data.gearClassData[item.classId]
							let num = 1
							let newNum = ''
							let resultArr = []
							let onlineSum = 0
							res.data.gearClassData[item.classId].forEach((item, index) => {
								let resultObj = {}
								switch (num) {
									case 1:
										newNum = '一档上线率'
										break
									case 2:
										newNum = '二档上线率'
										break
									case 3:
										newNum = '三档上线率'
										break
									case 4:
										newNum = '四档上线率'
										break
									case 5:
										newNum = '五档上线率'
										break
								}
								// item.onlineRate = num + '档上线率'
								item.onlineRate = newNum
								num++
								onlineSum += parseFloat(item.stuPropor)
								resultObj.value = parseFloat(item.stuPropor)
								resultObj.name = item.onlineRate
								resultArr.push(resultObj)
								if (index == gearClassData.length - 1) {
									var newResultObj = {}
									newResultObj.value = (100 - parseFloat(onlineSum)).toFixed(2) //其他人数（百分比）
									newResultObj.name = '未上档'
									resultArr.push(newResultObj)
								}
							})
							this.classData = resultArr
						}
					})
				}
			})
		},
		getTotalGradeData(type, newClassIds) {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				// examId: '221',
				// schoolId: '252',
				examSubjectId: '',
				type: type,
				classIds: newClassIds
			}
			this.$post('reportApi/gearReportSchool', params).then(res => {
				if (res.code == '200') {
					let classX = []
					let allData = []
					this.resultArr = []
					this.size = res.data.size
					this.gradeLine = res.data.headOneString
					this.gradingGrade = res.data.headTwoString
					this.totalStudentsGrading = res.data.headThreeString
					this.classOnlineData = res.data.table
					this.maxClassScore = res.data.maxClassScore
					this.minClassScore = res.data.minClassScore
					this.classesAll = res.data.classNameAll
					this.newCheckedClasses = res.data.classNames
					this.minClass = res.data.minClass
					this.maxClass = res.data.maxClass
					if (this.newFlag) {
						this.getAllClass(res)
						res.data.classNumbers.split('|').forEach((item, index) => {
							let restluObj = {}
							allData.push(JSON.parse(item).reverse())
							restluObj.name = this.classDataTitle[index].className
							restluObj.data = JSON.parse(item).reverse()
							restluObj.type = 'line'
							restluObj.flag = true
							this.resultArr.push(restluObj)
						})
						this.max = Math.max(...allData.flat(2)) + 3
						this.interval = Math.ceil(this.max / 10)
						this.newClassDataFake = this.resultArr
						let tempArr = []
						this.resultArr.forEach(res => {
							tempArr.push(
								Object.assign({}, res, {
									// smooth: true,
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: '#009688'
										}
									},
									tooltip: {
										show: true
									}
								})
							)
						})
						if (this.resultArr.length > 5) {
							this.newClassData = tempArr.splice(0, 5)
						} else {
							this.newClassData = tempArr
						}
					} else {
						this.closeDialog()
					}

					res.data.parameterList.forEach((item, index) => {
						classX.push(item.cnD)
						if (index === 0) {
							this.classOneOnlineData = res.data.gearReportMap[item.pkId]
							for (var i = 0; i < this.classOneOnlineData.length; i++) {
								for (var j = 0; j < this.classOneOnlineData.length - 1 - i; j++) {
									if (this.classOneOnlineData[j].studentNum > this.classOneOnlineData[j + 1].studentNum) {
										var classOne = this.classOneOnlineData[j + 1]
										this.classOneOnlineData[j + 1] = this.classOneOnlineData[j]
										this.classOneOnlineData[j] = classOne
									}
								}
							}
							this.newClassOneOnlineData = this.classOneOnlineData.map(item => {
								return {
									classNama: item.className,
									studentNum: item.studentNum,
									parameterId: item.parameterId
								}
							})
							//一档上线的各个班级人数
							this.oneOnlineRateMax = this.classOneOnlineData[this.classOneOnlineData.length - 1].className
							this.oneOnlineRateMin = this.classOneOnlineData[0].className
						} else if (index === 1) {
							this.classTwoOnlineData = res.data.gearReportMap[item.pkId]
							for (var m = 0; m < this.classTwoOnlineData.length; m++) {
								for (var n = 0; n < this.classTwoOnlineData.length - 1 - m; n++) {
									if (this.classTwoOnlineData[n].studentNum > this.classTwoOnlineData[n + 1].studentNum) {
										var classTwo = this.classTwoOnlineData[n + 1]
										this.classTwoOnlineData[n + 1] = this.classTwoOnlineData[n]
										this.classTwoOnlineData[n] = classTwo
									}
								}
							}
							this.newClassTwoOnlineData = this.classTwoOnlineData.map(item => {
								return {
									classNama: item.className,
									studentNum: item.studentNum,
									parameterId: item.parameterId
								}
							})
							this.twoOnlineRateMax = this.classTwoOnlineData[this.classTwoOnlineData.length - 1].className
							this.twoOnlineRateMin = this.classTwoOnlineData[0].className
						} else if (index === 2) {
							this.classThreeOnlineData = res.data.gearReportMap[item.pkId]
							for (var k = 0; k < this.classThreeOnlineData.length; k++) {
								for (var l = 0; l < this.classThreeOnlineData.length - 1 - k; l++) {
									if (this.classThreeOnlineData[l].studentNum > this.classThreeOnlineData[l + 1].studentNum) {
										var classThree = this.classThreeOnlineData[l + 1]
										this.classThreeOnlineData[l + 1] = this.classThreeOnlineData[l]
										this.classThreeOnlineData[l] = classThree
									}
								}
							}
							this.newClassThreeOnlineData = this.classThreeOnlineData.map(item => {
								return {
									classNama: item.className,
									studentNum: item.studentNum,
									parameterId: item.parameterId
								}
							})
							this.threeOnlineRateMax = this.classThreeOnlineData[this.classThreeOnlineData.length - 1].className
							this.threeOnlineRateMin = this.classThreeOnlineData[0].className
						}
					})
					this.classGradeX = classX.reverse()
				}
			})
		},
		chageSelect(classId) {
			this.getOnlineRateData(classId, this.newType)
		},
		settingGrade() {
			this.dialogVisible = false
		},
		handleClose(done) {
			done()
		},
		openClassDialog() {
			this.checkedclasses = []
			this.dialogVisible = true
			this.newCheckedClasses.forEach(item => {
				this.checkedclasses.push(item.className)
			})
		},
		getAllClass(res) {
			this.allSelectClassData = []
			this.classDataTitle = res.data.classNames
			res.data.classNameAll.forEach(item => {
				let classObj = {}
				classObj.className = item.className
				classObj.classCheckedFlag = false
				this.allSelectClassData.push(classObj)
			})
			// this.classDataTitle = this.allSelectClassData
		},
		/*****************************************************************************/

		chageGrading(type) {
			this.newClassIds = ''
			this.newType = type
			this.getTotalGradeData(this.newType, this.newClassIds)
			this.getOnlineRateData(this.classes, this.newType)
		},
		choseAllClass() {
			this.classIds = ''
			this.indeterminate = false
			if (this.checkedclasses.length !== this.allSelectClassData.length) {
				this.checkedclasses = []
				let classId = []
				this.allSelectClassData.forEach(res => {
					this.checkedclasses.push(res.className)
					classId.push(res.classCode)
				})
				this.classIds = classId + ''
			}
		},
		handleCheckedClassesChange(val) {
			this.classIds = ''
			this.newClassIds = ''
			this.checkedclasses = val
			this.checkedclasses.forEach(newItem => {
				this.classesAll.forEach(item => {
					if (item.className == newItem) {
						this.classIds += item.classCode + ','
						this.newClassIds = this.classIds.slice(0, this.classIds.length - 1)
					}
				})
			})
			if (this.checkedclasses.length !== this.allSelectClassData.length && this.checkedclasses.length > 0) {
				this.indeterminate = true
			}
			if (this.checkedclasses.length == 0) {
				this.newClassIds = '0'
			}
		},
		// 选中 确定
		closeDialog() {
			if (this.checkedclasses.length > 5) {
				this.$message('班级个数最多不能超过5个')
				this.dialogVisible - true
			} else {
				this.dialogVisible = false
			}
			this.getTotalGradeData(this.newType, this.newClassIds)
		}
	}
}
</script>

<style lang="less" scoped>
.el-button--info {
	background-color: #009688;
	border-color: #009688;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #009688;
	border-color: #009688;
	color: #009688;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
	color: #009688;
}
/deep/.el-button:hover {
	background-color: #009688;
	border-color: #009688;
	color: white;
}
/deep/.el-checkbox {
	width: 40px;
}
/deep/.el-checkbox-group {
	height: 320px;

	overflow-y: scroll;
}
.TotalOnline-people {
	height: auto;
	margin: 10px 0px;
	padding: 30px;
	border: 1px solid #ebeef5;
	background-color: #fff;
	color: #303133;
	transition: 0.3s;
	.TotalOnline-cont {
		height: auto;
		// background-color: wheat;
		.TotalOnline-title {
			margin-bottom: 20px;
			& > span:nth-child(1) {
				font-size: 18px;
				font-weight: bold;
				margin-right: 20px;
			}
			& > span:nth-child(2) {
				font-size: 12px;
				color: #6a6a6a;
			}
		}
		.set-grade-avg {
			/deep/.el-dialog {
				width: 60% !important;
			}
			/deep/.el-form-item {
				margin-bottom: 7px;
			}
			/deep/.el-form-item__label {
				width: 111px !important;
				text-align: left;
			}
			.grading-table {
				height: auto;
				/deep/.cell {
					text-align: center;
				}
				/deep/.el-input--mini {
					width: 40%;
				}
				span {
					padding-left: 10px;
				}
			}
			.grading-tips {
				margin-top: 10px;
				height: 34px;
				background-color: #fef0f0;
				color: #f56c6c;
				line-height: 34px;
				> span {
					padding-left: 20px;
				}
			}
			.critical-grade {
				margin-top: 16px;
				/deep/.el-input--mini {
					width: 10%;
					margin-right: 5px;
				}
			}
			/deep/.el-input__inner {
				text-align: center;
			}
			/deep/.el-dialog__header {
				text-align: center;
			}
			/deep/.el-dialog__footer {
				text-align: center;
			}
		}
		.level-desc {
			/deep/.el-input {
				width: 97%;
			}
			position: relative;
			color: #fff;
			margin-bottom: 20px;
			margin-top: 20px;
			padding: 5px 20px;
			background-color: #009688;
			height: auto;
			& > p:nth-child(1) {
				margin-top: 21px;
				margin-bottom: 25px;
				span:nth-child(1) {
					padding-right: 30px;
					font-size: 18px;
				}
				span:nth-child(2) {
					font-size: 12px;
				}
			}
			& > p:nth-child(2) {
				margin-bottom: 25px;
				span {
					font-size: 14px;
				}
			}
			.set-level-btn {
				position: absolute;
				top: 20px;
				right: 20px;
				padding: 7px 15px;
				font-size: 12px;
				border-radius: 3px;
				background: #fff;
				border: 1px solid #dcdfe6;
				color: #606266;
				white-space: nowrap;
				text-align: center;
				box-sizing: border-box;
				&:hover {
					cursor: pointer;
					color: #909399;
				}
			}
			.setting-grading {
				position: absolute;
				top: 22px;
				right: 25px;
			}
		}
		.onlinePepple-table {
			position: relative;
			margin-top: 15px;
			height: auto;
			// background-color: gold;
			.online-desc {
				height: 38px;
				display: flex;
				align-items: center;
				margin-bottom: 5px;
				span {
					flex-grow: 1;
				}
			}
			.online-table-show {
				.el-table {
					/deep/.cell {
						text-align: center;
					}
				}
				.el-table:nth-child(1) {
					flex-grow: 1.27;
				}
				.el-table:nth-child(2),
				.el-table:nth-child(3) {
					flex-grow: 1;
				}
			}
		}
		.onlinePeople-show {
			margin-top: 20px;
			font-size: 14px;
			padding: 20px;
			background: rgba(197, 233, 248, 0.2);
			box-sizing: border-box;
			height: auto;
			// background-color: coral;
			p {
				margin-bottom: 10px;
			}
			.level-block {
				font-size: 12px;
				margin-top: 10px;
				box-sizing: border-box;
				height: auto;
				overflow: hidden;
				// border: 1px solid skyblue;o
				//div {
				//	float: left;
				//	padding-left: 10px;
				//	padding-right: 10px;
				//	box-sizing: border-box;
				//}
				.level-block-desc {
					width: 66%;
					height: 310px;
					background-color: #fff;
					.block-cont {
						width: 100%;
						margin-bottom: 10px;
						height: 150px;
						border: 1px solid #eee;
						padding: 10px;
						background-color: #fbfdfe;
						white-space: nowrap;
						overflow: auto;
						box-sizing: border-box;
						.block-item {
							width: 30%;
							height: 120px;
							float: left;
							margin-top: 5px;
							color: #00c951;
							// display: flex;
							// flex-direction: column;
							// align-content: center;
							// border: 1px solid skyblue;
							box-sizing: border-box;
							border-right: 1px solid #eee;
							margin-right: 10px;
							&:nth-child(3) {
								margin-right: 0;
								border-right: 1px solid transparent;
								width: 20%;
								margin-left: 35px;
							}
							&:nth-child(1) {
								margin-left: 21px;
							}
							> p {
								color: rgb(0, 0, 0);
								margin-top: 27px;
							}
						}
					}
				}
				.chart-block {
					width: 33.1%;
					background-color: #fbfdfe;
					height: auto;
					border: 1px solid #eee;
					//&:nth-child(3n+2){
					//  margin-right: 10px;
					//}
					.block-select {
						width: 350px;
						height: auto;
						margin: 11px 0;
						.el-select {
							float: right;
						}
					}
					.chartInstance {
						width: 350px;
						height: 250px;
					}
					// .chart-instance {
					// 	width: 350px;
					// 	height: 250px;
					// }
				}
			}
		}
		.critical-title {
			margin-bottom: 10px;
			& > span:nth-child(1) {
				font-size: 18px;
				color: #333;
				margin-right: 20px;
			}
			& > span:nth-child(2) {
				font-size: 12px;
				color: #6a6a6a;
			}
		}
		.critical-desc {
			height: auto;
			box-sizing: border-box;
			overflow: hidden;
			p {
				margin: 12px 0;
			}
		}
		.class-test-cont {
			height: auto;
			.classTest-title {
				margin-bottom: 10px;
				box-sizing: border-box;
				> span:nth-child(1) {
					font-size: 18px;
					color: #333;
					margin-right: 20px;
				}
				> span:nth-child(2) {
					font-size: 12px;
					color: #6a6a6a;
				}
			}
			.classTest-show {
				height: auto;
				box-sizing: border-box;
				overflow: hidden;
				.classTest-echarts {
					width: 75%;
					height: 360px;
					padding-left: 10px;
					padding-right: 10px;
					margin-top: 10px;
					margin-bottom: 10px;
					float: left;
					box-sizing: border-box;
					background: #fff;
				}
				.classTest-echarts-desc {
					width: 25%;
					height: auto;
					padding-left: 10px;
					padding-right: 10px;
					margin-top: 10px;
					margin-bottom: 10px;
					float: left;
					box-sizing: border-box;
					// background-color: coral;
					.HighScore-class,
					.LowScore-class {
						height: auto;
						margin-top: 10px;
						margin-bottom: 10px;
						border: 1px solid #ebeef5;
						background-color: #fff;
						color: #303133;
						-webkit-transition: 0.3s;
						transition: 0.3s;
						border-radius: 4px;
						overflow: hidden;
						.HighScore-class-cont,
						.LowScore-class-cont {
							height: auto;
							padding: 20px;
							> p:nth-child(1) {
								font-size: 12px;
								margin: 10px 0;
							}
							> p:nth-child(2) {
								color: rgb(238, 107, 82);
								font-size: 30px;
							}
							> p.LowScore-p {
								color: rgb(105, 193, 112);
							}
						}
						&:hover {
							box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
						}
					}
					.LowScore-class {
						margin-top: 20px;
					}
					.grade-conclusion {
						font-size: 12px;
						color: rgb(106, 106, 106);
					}
				}
				.setting-class {
					.class-title {
						display: flex;
						align-items: center;
						margin-bottom: 10px;
						> span {
							flex-grow: 1;
						}
					}
					.classTitle-p {
						font-size: 12px;
						color: #f56c6c;
					}
					.class-select {
						display: flex;
						flex-direction: column;
						height: 300px;
						// background-color: antiquewhite;
						margin-top: 10px;
						margin-left: 30px;
					}
					/deep/.el-dialog {
						width: 50% !important;
					}
					/deep/.el-dialog__body {
						padding: 14px 20px;
					}
					/deep/.el-input {
						width: 20%;
					}
					/deep/.el-checkbox {
						margin-bottom: 5px;
					}
					/deep/.el-checkbox-group {
						display: flex;
						flex-direction: column;
					}
				}
			}
		}
	}
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	.cls-wrap {
		width: 100%;
		height: auto;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		.cls-wrap-list {
			font-size: 18px;
			margin: 0 10px 10px 0;
			color: #fcbb12;
		}
	}
	.cls-wrap-title {
		text-align: center;
	}
}
</style>
